import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProgressBar, button, Card, Badge } from "react-bootstrap";
import { fetchCandidateDetailbyID, fetchCandidateSkillbyID, fetchCandidateExperiencebyID, fetchCandidateEducationsbyID, updateBasicInfo, deleteResume } from "../../api/CandidateAPI";
import ProfileSection from "../../components/JobSeekerProfileSection";
import {updateUserById} from "../../api/UserAPI";
import DynamicModal from "../../components/DynamicModal";
import "../../assets/css/availabilityStatus.css";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext"; // adjust path

export default function JobSeekerProfile() {
  const [isEditing, setIsEditing] = useState(false);
  const [candidateDet, setCandidateDet] = useState([]);
  const [candidateSkillDet, setCandidateSkillDet] = useState([]);
  const [candidateEducationDet, setCandidateEducationDet] = useState([]);
  const [candidateExperienceDet, setCandidateExperienceDet] = useState([]);
  const [message, setMessage] = useState({ type: "", text: "" });
  const userId = localStorage.getItem("uId");
  const appUserId = localStorage.getItem("aUId");
  const token = localStorage.getItem("otoken");
  const jsId = localStorage.getItem("jsId");
  const fullName = localStorage.getItem("name");
  const profilePic = localStorage.getItem("profilePic");
  
  const navigate = useNavigate();
  const availabilityLabels = {
    "available": "Available",
    "donotdisturb": "Do Not Disturb",
    "onleave": "On Leave",
  };

const [modalData, setModalData] = useState({ title: "", body: null, onSave: null });
const [showModal, setShowModal] = useState(false);
const [headline, setHeadline] = useState("");
 const { setProfilePic } = useContext(UserContext);

const [profileData, setProfileData] = useState({
  phone: candidateDet?.candidate?.phone_number || "",
  email: candidateDet?.candidate?.email || "",
  linkedin: candidateDet?.candidate?.linkedin_url || "",
  location: candidateDet?.candidate?.current_location || "",
  experience: candidateDet?.candidate?.experience || ""
});

const resumeUrl = `${process.env.REACT_APP_JOB_BOARD_RESUME_URL}/${candidateDet.candidate?.resume_url}` ?? null;
console.log("RESUME URL ::: ", resumeUrl);

// const handleResumeUpload = async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const formData = new FormData();
//   formData.append("candidate_resume", file); // 👈 must match multer field name

//   try {
//     const res = await updateBasicInfo(appUserId, formData, token);
//     setMessage({ type: "success", text: "Resume uploaded successfully." });
//     console.log("Updated data:", res);
//   } catch (error) {
//     console.error("Resume upload failed:", error);
//     setMessage({ type: "error", text: "Resume upload failed." });
//   }
// };


const handleResumeUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("candidate_resume", file);

  try {
    const res = await updateBasicInfo(appUserId, formData, token);

    setMessage({ type: "success", text: "Resume uploaded successfully." });

    // ✅ Update state immediately with new resume name
    setCandidateDet((prev) => ({
      ...(prev || {}),
      candidate: {
        ...(prev?.candidate || {}),
        resume_url: res?.data?.resume_url || file.name, // use API response or fallback to file name
      },
    }));
  } catch (error) {
    console.error("Resume upload failed:", error);
    setMessage({ type: "error", text: "Resume upload failed." });
  }
};



// const handleResumeDownload = () => {
//   // Use public URL or generate using backend API
//   window.open(resumeUrl, "_blank"); // resumeUrl is path to the file from API/db
// };

const handleResumeDelete = async () => {
  try {
    await deleteResume(appUserId, token);
    setMessage({ type: "success", text: "Resume deleted successfully." });

    // ✅ Update state (resume_url → null)
    setCandidateDet((prev) => ({
      ...prev,
      candidate: {
        ...(prev?.candidate || {}),
        resume_url: null,
      },
    }));
  } catch (error) {
    setMessage({ type: "error", text: "Resume delete failed." });
  }
};



 const handleProfilePicChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    try {
      const formData = new FormData();
      formData.append("auth_user_profile_pic_url", file);
      const res = await updateUserById(userId, formData, token);
      const imagePath = res.updatedFields?.auth_user_profile_pic_url;
      const imageUrl = imagePath ? `${process.env.REACT_APP_C2AS_UPLOAD_URL}/${imagePath}` : null;
      localStorage.setItem("profilePic", imageUrl);
      setProfilePic(imageUrl);
      setMessage({ type: "success", text: "Profile photo updated." });
      closeModal();
    } catch (error) {
      setMessage({ type: "error", text: "Upload failed." });
    }
  };

const handleRemoveProfilePic = async () => {
  try {
    const payload = { auth_user_profile_pic_url: null };
    const res = await updateUserById(userId, payload, token);
    localStorage.removeItem("profilePic");
    setProfilePic(null);
    setMessage({ type: "success", text: "Profile photo removed." });
    closeModal();
  } catch (error) {
    setMessage({ type: "error", text: "Could not remove profile photo." });
  }
};
  useEffect(() => {
    if (!appUserId || !token) {
      console.warn("User ID or token missing");
      return;
    }
    
  

            
    const fetchBasicData = async () => {
      console.log("Calling fetchCandidateDetailbyID");
      try {
        const data = await fetchCandidateDetailbyID(appUserId, token);
        setCandidateDet(data);
        localStorage.setItem("jsId", data.candidate.seeker_id);
        // console.log("data.candidate.seeker_id :::: ",data.candidate.seeker_id);
      } catch (error) {
        console.error("API failed:", error);
        setMessage({ type: "error", text: "Could not load profile" });
      }
    };

    const fetchSkillData = async () => {
      console.log("Calling fetchCandidateDetailbyID");
      try {
        const data = await fetchCandidateSkillbyID(jsId, token);
        setCandidateSkillDet(data);
        // console.log("data.candidate.seeker_id :::: ",data.candidate.seeker_id);
      } catch (error) {
        console.error("API failed:", error);
        setMessage({ type: "error", text: "Could not load profile" });
      }
    };

    const fetchExperienceData = async () => {
      console.log("Calling fetchCandidateDetailbyID");
      try {
        const data = await fetchCandidateExperiencebyID(jsId, token);
        setCandidateExperienceDet(data);
        console.log("DATAAAAAAA :::: ", data);
      } catch (error) {
        console.error("API failed:", error);
        setMessage({ type: "error", text: "Could not load profile" });
      }
    };

    const fetchEducationData = async () => {
      console.log("Calling fetchCandidateDetailbyID");
      try {
        const data = await fetchCandidateEducationsbyID(jsId, token);
        setCandidateEducationDet(data);
        // console.log("data.candidate.seeker_id :::: ",data.candidate.seeker_id);
      } catch (error) {
        console.error("API failed:", error);
        setMessage({ type: "error", text: "Could not load profile" });
      }
    };

    fetchBasicData();
    fetchEducationData();
    fetchExperienceData();
    fetchSkillData();
  }, []);





const openModal = (title, body, onSave) => {
  setModalData({ title, body, onSave });
  setShowModal(true);
};

const closeModal = () => {
  setShowModal(false);
  setModalData({ title: "", body: null, onSave: null });
};


const handleEditProfileField = (initialData) => {
  let draftData = { ...initialData };
  console.log("on click");
  openModal(
    "Edit Profile",
    <EditFieldForm
      initialData={initialData}
      onValueChange={(val) => { draftData = val; }}
    />,
    async () => {
      try {
        const data = await updateBasicInfo(appUserId, draftData, token);

        // Update local state
        setCandidateDet((prev) => ({
          ...(prev || {}),
          candidate: {
            ...(prev?.candidate || {}),
            ...draftData,
          },
        }));
        setMessage({ type: "success", text: "Profile updated." });
      } catch (error) {
        setMessage({ type: "error", text: "Could not update profile" });
      }
      closeModal();
    }
  );
};


/** Profile Headline */
const handleEditHeadline = async () => {
  // 1. Fetch latest data using your API function
  const data = await fetchCandidateDetailbyID(appUserId, token);
  const latestHeadline = data?.candidate?.profile_headline || "";

  let headlineDraft = latestHeadline;


  openModal(
    "Edit Resume Headline",
    <EditHeadlineForm
      initialValue={latestHeadline}
      maxChars={250}
      onValueChange={(val) => { headlineDraft = val; }}
    />,
    async () => {
      try {          
        const data = await updateBasicInfo(appUserId, { profile_headline: headlineDraft }, token); 
        setHeadline(headlineDraft);         
        setCandidateDet((prev) => ({
          ...(prev || {}),
          candidate: {
            ...(prev?.candidate || {}),
            profile_headline: headlineDraft,
          },
        }));
        console.log("Updated candidateDet:", {
          ...(candidateDet || {}),
          candidate: {
            ...(candidateDet?.candidate || {}),
            profile_headline: headlineDraft,
          },
        });


      } catch (error) {
        console.error("API failed:", error);
        setMessage({ type: "error", text: "Could not update resume headline" });
      }
      closeModal();
    }
  );
};

const EditFieldForm = ({ initialData, onValueChange }) => {
  const [form, setForm] = useState(initialData || {});

  // keep parent in sync when form changes
  useEffect(() => {
    if (onValueChange) onValueChange(form);
  }, [form]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <form>
      {/* Phone Number */}
      <div className="mb-3 row">
        <label className="col-sm-3 col-form-label fw-bold">
          <i className="fa fa-phone me-2"></i> Phone Number
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            name="phone"
            className="form-control"
            value={form.phone || ""}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Email */}
      <div className="mb-3 row">
        <label className="col-sm-3 col-form-label fw-bold">
          <i className="fa fa-envelope me-2"></i> Email
        </label>
        <div className="col-sm-9">
          <input
            type="email"
            name="email"
            className="form-control"
            value={form.email || ""}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* LinkedIn */}
      <div className="mb-3 row">
        <label className="col-sm-3 col-form-label fw-bold">
          <i className="fa fa-linkedin me-2"></i> LinkedIn
        </label>
        <div className="col-sm-9">
          <input
            type="url"
            name="linkedin"
            className="form-control"
            value={form.linkedin || ""}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Location */}
      <div className="mb-3 row">
        <label className="col-sm-3 col-form-label fw-bold">
          <i className="fa fa-map-marker me-2"></i>Current Location
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            name="location"
            className="form-control"
            value={form.location || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label className="col-sm-3 col-form-label fw-bold">
          <i className="fa fa-map-marker me-2"></i>Preferred Location
        </label>
        <div className="col-sm-9">
          <input
            type="text"
            name="preferred_location"
            className="form-control"
            value={form.preferred_location || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      {/* Experience */}
<div className="mb-3 row">
  <label className="col-sm-3 col-form-label fw-bold">
    <i className="fa fa-briefcase me-2"></i> Experience
  </label>
  <div className="col-sm-9 d-flex gap-2">
    {/* Years */}
    <select
      name="exp_in_years"
      className="form-control"
      value={form.exp_in_years || ""}
      onChange={handleChange}
    >
      <option value="">Years</option>
      {Array.from({ length: 51 }, (_, i) => (
        <option key={i} value={i}>{i}</option>
      ))}
    </select>

    {/* Months */}
    <select
      name="exp_in_months"
      className="form-control"
      value={form.exp_in_months || ""}
      onChange={handleChange}
    >
      <option value="">Months</option>
      {Array.from({ length: 12 }, (_, i) => (
        <option key={i} value={i}>{i}</option>
      ))}
    </select>

    {/* Days */}
    <select
      name="exp_in_days"
      className="form-control"
      value={form.exp_in_days || ""}
      onChange={handleChange}
    >
      <option value="">Days</option>
      {Array.from({ length: 31 }, (_, i) => (
        <option key={i} value={i}>{i}</option>
      ))}
    </select>
  </div>
</div>

    </form>
  );
};


const EditHeadlineForm = ({ initialValue, maxChars, onSave, onValueChange }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (onValueChange) onValueChange(value); // keep parent in sync
  }, [value]);

  return (
    <form>
      <div className="mb-3">
        <textarea
          className="form-control"
          maxLength={maxChars}
          rows="5"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        ></textarea>
        <small className="text-muted">
          {maxChars - value.length} characters left
        </small>
      </div>
    </form>
  );
};

/** Profile Summary */
const handleEditProfileSummary = async () => {
  try {
    // 1. Fetch latest profile data
    const data = await fetchCandidateDetailbyID(appUserId, token);
    const latestSummary = data?.candidate?.profile_summary || "";

    let summaryDraft = latestSummary;

    // 2. Open modal with Edit form
    openModal(
      "Edit Profile Summary",
      <EditProfileSummaryForm
        initialValue={latestSummary}
        maxChars={500}
        onValueChange={(val) => { summaryDraft = val; }}
      />,
      async () => {
        try {
          // 3. Call update API
          await updateBasicInfo(appUserId, { profile_summary: summaryDraft }, token);

          // 4. Update state
          setCandidateDet((prev) => ({
            ...(prev || {}),
            candidate: {
              ...(prev?.candidate || {}),
              profile_summary: summaryDraft,
            },
          }));

          console.log("Updated profile summary:", summaryDraft);
        } catch (error) {
          console.error("API failed:", error);
          setMessage({ type: "error", text: "Could not update profile summary" });
        }
        closeModal();
      }
    );
  } catch (error) {
    console.error("Error fetching profile summary:", error);
    setMessage({ type: "error", text: "Could not fetch profile summary" });
  }
};

const EditProfileSummaryForm = ({ initialValue, maxChars, onValueChange }) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (onValueChange) onValueChange(value);
  }, [value]);

  return (
    <form>
      <div className="mb-3">
        <textarea
          className="form-control"
          maxLength={maxChars}
          rows="6"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <small className="text-muted">
          {maxChars - value.length} characters left
        </small>
      </div>
    </form>
  );
};

const ProfilePicUploader = ({ handleProfilePicChange, handleRemoveProfilePic, profilePic }) => (
  <div style={{ textAlign: "center" }}>
    <input
      type="file"
      accept="image/*"
      onChange={handleProfilePicChange}
      style={{ display: "none" }}
      id="profilePicInput"
    />
    <label htmlFor="profilePicInput" className="btn btn-outline-primary btn-sm mr-2">
      Upload New Photo
    </label>
    <button
      className="btn btn-outline-danger btn-sm"
      onClick={handleRemoveProfilePic}
      disabled={!profilePic}
    >
      Remove Photo
    </button>
  </div>
);



  return (
    <>

      <div className="content-body">
        <div className="row page-titles mx-0">
          <div className="col p-md-0">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="javascript:void(0)">Dashboard</a>
              </li>
              <li className="breadcrumb-item active">
                <a href="javascript:void(0)">Home</a>
              </li>
            </ol>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            {/* Left Sidebar */}
           
            {/* <div className="col-md-3">
              

              <div className="card mt-0">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="card-title mb-0">Personal details</h6>
                    <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => {
                      console.log("Clicked!"); 
                      handleEditProfileField(profileData);
                    }}
                  >
                    <i className="fa fa-pencil"></i>
                  </button>
                  </div>
                  <div className="row">
                   
                    <div className="col-md-6">
                      <p>
                        <strong>Gender</strong><br />
                        {candidateDet?.candidate?.gender === "Male" && (
                          <i className="fa fa-mars me-2"></i>
                        )}
                        {candidateDet?.candidate?.gender === "Female" && (
                          <i className="fa fa-venus me-2"></i>
                        )}
                        {candidateDet?.candidate?.gender !== "Male" &&
                          candidateDet?.candidate?.gender !== "Female" && (
                            <i className="fa fa-venus-mars me-2"></i>
                          )}
                        <span> {candidateDet?.candidate?.gender}</span>
                      </p>
                      <p>
                        <strong>Date of birth</strong><br />
                        {candidateDet?.candidate?.dob
                          ? new Date(candidateDet.candidate.dob).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          : "Add DOB"}
                      </p>

                     
                    </div>

                    
                    <div className="col-md-6">
                      <p>
                        <strong>Career break</strong><br />
                        {candidateDet?.candidate?.careerBreak ? "Yes" : "No"}
                      </p>
                       <p>
                        <strong>Differently abled</strong><br />
                        {candidateDet?.candidate?.isDifferentlyAbled ? "Yes" : "No"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mt-3">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="card-title mb-0">Career Profile</h6>
                    <button className="btn btn-link p-0">
                      <i className="fa fa-pencil"></i>
                    </button>
                  </div>
                  <div className="row">
                  
                    <div className="col-md-6">
                      <p>
                        <strong>Current industry</strong><br />
                        {candidateDet?.candidate?.industry}
                      </p>
                      <p>
                        <strong>Department</strong><br />
                        {candidateDet?.candidate?.functional_area}
                      </p>

                      <p>
                        <strong>Role category</strong><br />
                        {candidateDet?.candidate?.role_category}
                      </p>
                      <p>
                        <strong>Preferred shift</strong><br />
                        {candidateDet?.candidate?.preferred_shift}
                      </p>
                      <p>
                        <strong>Expected salary</strong><br />
                        {candidateDet?.candidate?.expected_salary}
                      </p>
                    </div>

                    
                    <div className="col-md-6">
                      <p>
                        <strong>Job role</strong><br />
                        {candidateDet?.candidate?.careerBreak ? "Yes" : "No"}
                      </p>

                      <p>
                        <strong>Desired job type</strong><br />
                        {candidateDet?.candidate?.desired_job_type
                          ? candidateDet.candidate.desired_job_type
                          : ""}
                      </p>
                      <p>
                        <strong>Desired employment type</strong><br />
                        {candidateDet?.candidate?.desired_employment_type
                          ? candidateDet.candidate.desired_employment_type
                          : ""}
                      </p>
                      
                    </div>
                  </div>
                </div>
              </div>

            </div> */}

            {/* Main Content */}
            <div className="col-md-12">
               <div className="col-lg-12">
              <div className="card mt-0">
                <div className="card-body">
                  

                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <div
                          className="bg-light d-flex align-items-center justify-content-center rounded-circle overflow-hidden"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "50%",
                            overflow: "hidden",
                            backgroundColor: "#f0f0f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {profilePic ? (
                            <img
                              src={profilePic}
                              alt="Profile"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <i className="fa fa-user text-muted fa-2x" />
                          )}
                        </div>
                        <button
                          className="btn btn-link p-0"
                          style={{
                            marginTop: "60px"
                          }}
                          title="Edit Profile Picture"
                          aria-label="Edit Profile Picture"
                          onClick={() =>
                            openModal(
                              "Change Profile Photo",
                              <ProfilePicUploader
                                handleProfilePicChange={handleProfilePicChange}
                                handleRemoveProfilePic={handleRemoveProfilePic}
                                profilePic={profilePic}
                              />,
                              null
                            )
                          }
                        >
                          <i className="fa fa-pencil fa-lg" />
                        </button>
                      </div>

                    <h2 className="ml-100">
                      {candidateDet?.candidate?.full_name
                        ? candidateDet.candidate.full_name
                        : ""}
                    </h2>
                    <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => {
                      console.log("Clicked!"); 
                      handleEditProfileField({
                          phone: candidateDet?.candidate?.phone_number || "",
                          email: candidateDet?.candidate?.email || "",
                          linkedin: candidateDet?.candidate?.linkedin_url || "",
                          location: candidateDet?.candidate?.current_location || "",
                          preferred_location: candidateDet?.candidate?.preferred_location || "",
                          exp_in_years: candidateDet?.candidate?.exp_in_years || "",
                          exp_in_months: candidateDet?.candidate?.exp_in_months || "",
                          exp_in_days: candidateDet?.candidate?.exp_in_days || "",
                        });
                      }}
                    >
                    <i className="fa fa-pencil"></i>
                    </button>
                  </div>
                  <div className="row">
                    {/* Left column */}
                    <div className="col-md-6">
                      <p>
                        <strong>Phone Number</strong><br />
                        <i className="fa fa-phone"></i>: {candidateDet?.candidate?.phone_number
                          ? candidateDet.candidate.phone_number
                          : ""}
                      </p>


                      <p>
                        <strong>LinkedIn URL</strong><br />
                        <i className="fa fa-linkedin"></i>: {candidateDet?.candidate?.linkedin_url
                          ? candidateDet.candidate.linkedin_url
                          : ""}
                      </p>
                       <p>
                        <strong>Current Location</strong><br />
                        <i className="fa fa-map-marker mr-2"></i>
                        {candidateDet?.candidate?.current_location
                          ? candidateDet.candidate.current_location
                          : ""}
                      </p>
                    </div>

                    {/* Right column */}
                    <div className="col-md-6">
                      <p>
                        <strong>Email</strong><br />
                        <i className="fa fa-envelope"></i>: {candidateDet?.candidate?.email
                          ? candidateDet.candidate.email
                          : ""}
                      </p>

                      <p>
                        <strong>Experience</strong><br />

                        <i className="fa fa-briefcase mr-2"></i>

                        {candidateDet?.candidate?.exp_in_years
                          ? candidateDet.candidate.exp_in_years + " Year(s) "
                          : "0 Year(s)"}
                        {candidateDet?.candidate?.exp_in_months
                          ? candidateDet.candidate.exp_in_months + " Month(s) "
                          : "0 Year(s)"}
                        {candidateDet?.candidate?.exp_in_days
                          ? candidateDet.candidate.exp_in_days + " Day(s)"
                          : "0 Year(s)"}
                      </p>
                            <p>
                        <strong>Preferred work location</strong><br />
                        <i className="fa fa-map-marker mr-2"></i>
                        {candidateDet?.candidate?.preferred_location
                          ? candidateDet.candidate.preferred_location
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              {/* Resume Section */}
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    {/* Header row */}
                    <div className="d-flex justify-content-between align-items-center">
                        <h6 className="card-title mb-0">Resume</h6>
                        
                        <div>
                         {/* Download Resume */}
                          {resumeUrl && (
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              title="Download Resume"
                              onClick={() => window.open(resumeUrl, "_blank", "noopener,noreferrer")}
                            >
                              <i className="fa fa-download"></i>
                            </button>
                          )}

                          {/* Delete */}
                          <button type="button" className="btn btn-light btn-sm rounded-circle" title="Delete" onClick={handleResumeDelete}>
                            <i className="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                      <p className="mt-2">
                        {candidateDet?.candidate?.resume_url ? (
                          <span>
                            <i className="fa fa-file-text-o me-2"></i>
                            {candidateDet.candidate.resume_url}
                          </span>
                        ) : (
                          <span className="text-muted">No resume uploaded</span>
                        )}
                      </p>


                      <div className="mt-3 p-3 text-center border rounded" style={{ borderStyle: "dashed" }}>
                        <input
                          type="file"
                          accept=".pdf,.doc,.docx,.rtf"
                          style={{ display: "none" }}
                          id="resumeInput"
                          onChange={handleResumeUpload}
                        />
                        <label htmlFor="resumeInput" className="btn btn-outline-primary btn-sm">
                          Upload Resume
                        </label>
                        <p className="text-muted mt-1 mb-0" style={{ fontSize: "0.85rem" }}>
                          Supported Formats: doc, docx, rtf, pdf, upto 2 MB
                        </p>
                      </div>

                  </div>
                </div>
              </div>
              {/* Resume Headline */}
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <h6 className="card-title mb-0">Profile Headline</h6>
                      <button
                        type="button"
                        className="btn btn-link p-0 d-flex align-items-center justify-content-center ml-2"
                        onClick={() => handleEditHeadline(headline)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                    </div>
                    <div className="mt-2">
                        <p>
                          <div className="mt-2">
                            <p>
                              {candidateDet?.candidate?.profile_headline
                                ? candidateDet.candidate.profile_headline
                                : "No resume headline added yet."}
                            </p>
                          </div>

                        </p>

                    </div>
                  </div>
                </div>
              </div>

              {/* Profile Summary */}
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <h6 className="card-title mb-0">Profile Summary</h6>
                      <button
                        type="button"
                        className="btn btn-link p-0  ml-2"
                        onClick={handleEditProfileSummary}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                    </div>
                    <div className="mt-2">
                      <p>
                        {candidateDet?.candidate?.profile_summary
                          ? candidateDet.candidate.profile_summary
                          : "No proflie summary added yet."}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              

              {/* Employment */}
              {/* <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="card-title mb-0">Employment</h6>
                      <button
                        type="button"
                        className="btn mb-1 btn-rounded btn-primary"
                      >
                        Add Employment
                      </button>
                    </div>
                    <div className="mt-2">
                      {candidateExperienceDet?.candidate?.length > 0 ? (
                        candidateExperienceDet.candidate.map((exp, index) => (
                          <div key={exp.id || index} className="mb-3">
                            <p><strong>{exp.job_title || "Job Title not provided"}</strong></p>
                            <p>
                              {exp.company_name || "Company not provided"}
                              {" | "}
                              {exp.start_date ? exp.start_date : "Start Date not provided"} -{" "}
                              {exp.end_date || "Present"}
                            </p>
                            <p>{exp.location || "Location not provided"}</p>
                          </div>
                        ))
                      ) : (
                        <p>No experiences found</p>
                      )}
                    </div>


                  </div>
                </div>
              </div> */}

              {/* Education */}
              {/* <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="card-title mb-0">Education</h6>
                      <button
                        type="button"
                        className="btn mb-1 btn-rounded btn-primary"
                      >
                        Add Education
                      </button>
                    </div>
                    <div className="mt-2">
                      {candidateEducationDet?.candidate?.length > 0 ? (
                        candidateEducationDet.candidate.map((edu, index) => (
                          <div key={edu.id || index} className="mb-3">
                            <p><strong>{edu.degree || "Degree not provided"}</strong></p>
                            <p>
                              {edu.institution_name || "Institution not provided"}
                              {edu.field_of_study ? ` | ${edu.field_of_study}` : ""}
                            </p>
                            <p>
                              {edu.start_date ? edu.start_date : "Start Date not provided"} -{" "}
                              {edu.end_date || "Present"}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p>No education details found</p>
                      )}
                    </div>

                  </div>
                </div>
              </div> */}

              {/* IT Skills */}
              {/* <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="card-title mb-0">IT Skills</h6>
                      <button
                        type="button"
                        className="btn mb-1 btn-rounded btn-primary"
                      >
                        Add IT Skills
                      </button>
                    </div>
                    <div className="mt-2">
                      {candidateSkillDet?.candidate?.length > 0 ? (
                        <ul className="list-unstyled">
                          {candidateSkillDet.candidate.map((skill, index) => (
                            <li key={skill.id || index} className="mb-2">
                              <strong>{skill.skill_name || "Skill not provided"}</strong>
                              {skill.proficiency_level ? ` - ${skill.proficiency_level}` : ""}
                              {skill.experience_years
                                ? ` (${skill.experience_years} yrs experience)`
                                : ""}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>No skills added yet</p>
                      )}
                    </div>

                  </div>
                </div>
              </div> */}

            </div>

            {/* Right Side Boosters */}
            {/* <div className="col-md-3">
              <Card>
                <Card.Body>
                  <h6>Complete Your Profile</h6>
                  <p>Add preferred location +2%</p>
                  <p>Add photo +5%</p>
                  <button variant="warning" size="sm">Add 2 missing details</button>
                </Card.Body>
              </Card>
            </div> */}
          </div>
        </div>
      </div>
      
    <DynamicModal
      show={showModal}
      title={modalData.title}
      body={modalData.body}
      onSave={modalData.onSave}
      onClose={closeModal}
    />
    </>
  );
}